<template>
  <div>
    <div id="loaderoverlay" v-bind:style="{ display: onloader }">
      <div class="w-100 d-flex justify-content-center align-items-center">
        <div class="loaderspinner"></div>
      </div>
    </div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
      <router-link to="/dashboard" class="text-white pl-3">
        <i class="ni ni-tv-2"></i> Dashborad
      </router-link>
      <span class="text-white"><i class="ni ni-bold-right"></i>Message</span>
    </base-header>

    <!--Charts-->
    <div class="container-fluid mt--7">
      <card header-classes="bg-transparent">
        <div v-if="openform">
          <div class="card bg-secondary border-0 mb-0">
            <div class="card-body">
              <div class="form-horizontal">
                <form role="form" @submit.prevent="submitdata">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>Youtube Message Video Embed</label>
                        <textarea
                          v-model="MessageEmbededBodyval"
                          class="form-control"
                          required
                        ></textarea>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>Message Title</label>
                        <textarea
                          v-model="MessageTitleval"
                          class="form-control"
                          required
                        ></textarea>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Message By</label>
                        <textarea
                          v-model="DeliveryByval"
                          class="form-control"
                          required
                        ></textarea>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label>Message Date</label>
                        <input
                          v-model="DateDeliveredval"
                          type="date"
                          class="form-control"
                          required
                        />
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div class="text-center mb-3">
                    <button
                      type="button"
                      @click.stop="closeform()"
                      class="btn btn-secondary"
                    >
                      Cancel
                    </button>
                    <button type="submit" class="btn btn-primary my-4">
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="form-inline">
            <button
              type="button"
              @click.prevent="newterm"
              class="btn btn-default"
            >
              <i class="ni ni-fat-add"></i>Add New
            </button>
            <div class="input-group">
              <input
                v-model="searchval"
                class="form-control"
                @keyup="getsearch"
                placeholder="Search..."
              />
              <div class="input-group-append">
                <button
                  type="button"
                  @click.prevent="getsearch"
                  class="btn btn-secondary"
                >
                  <i class="fa fa-search"></i> Search
                </button>
              </div>
            </div>
          </div>
          <div class="table-responsive">
            <table class="table table-bordered table-hover">
              <thead>
                <tr>
                  <th></th>
                  <th>Message Title</th>
                  <th>Message By</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in resultitems" :key="item.Id">
                  <td>
                    <button
                      class="btn btn-secondary btn-sm my-2"
                      v-on:click="edititem(item.Id)"
                    >
                      <i class="fa fa-edit"></i> Edit
                    </button>
                  </td>
                  <td>{{ item.MessageTitle }}</td>
                  <td>{{ item.DeliverBy }}</td>
                  <td>{{ item.DateDelivered | formatDate }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import swal from "sweetalert";
export default {
  name: "Message",
  data() {
    return {
      Idval: 1,
      MessageEmbededBodyval: "",
      MessageTitleval: "",
      DeliveryByval: "",
      DateDeliveredval: null,
      resultitems: null,
      searchval: "",
      process: "N",
      openform: false,
      onloader: "none",
    };
  },
  methods: {
    newterm: function () {
      this.MessageEmbededBodyval = "";
      this.MessageTitleval = null;
      this.DeliveryByval = "";
      this.DateDeliveredval = "";
      this.openform = true;
      this.process = "N";
    },
    closeform: function () {
      this.MessageEmbededBodyval = "";
      this.MessageTitleval = null;
      this.DeliveryByval = "";
      this.DateDeliveredval = "";
      this.openform = false;
      this.process = "N";
    },
    edititem: function (Id) {
      this.onloader = "flex";
      this.$store
        .dispatch("getmessagebyid", Id)
        .then((resp) => {
          this.Idval = resp.Id;
          this.MessageEmbededBodyval = resp.MessageEmbedBody;
          this.MessageTitleval = resp.MessageTitle;
          this.DeliveryByval = resp.DeliverBy;
          this.DateDeliveredval = this.frontEndDateFormat(resp.NotifyDate);
          this.openform = true;
          this.process = "U";
          this.onloader = "none";
        })
        .catch((err) => {
          this.onloader = "none";
          this.checkresponse(err.response.data);
        });
    },
    submitdata: function () {
      let Id = this.Idval;
      let MessageEmbededBody = this.MessageEmbededBodyval;
      let MessageTitle = this.MessageTitleval;
      let DeliveryBy = this.DeliveryByval;
      let DateDelivered = this.DateDeliveredval;
      let Operation = this.process;
      let Username = this.$store.state.auth.token;
      this.onloader = "flex";
      let userdata = {
        Id,
        MessageEmbededBody,
        MessageTitle,
        DeliveryBy,
        DateDelivered,
        Operation,
        Username,
      };
      this.$store
        .dispatch("processmessage", userdata)
        .then((resp) => {
          this.resultitems = resp;
          this.closeform();
          this.onloader = "none";
          swal({
            title: "Success!",
            text: "Submitted successfully",
            icon: "success",
            button: "Ok",
          });
        })
        .catch((err) => {
          this.onloader = "none";
          this.checkresponse(err.response.data);
        });
    },
    getmessage: function () {
      this.onloader = "flex";
      this.$store
        .dispatch("getmessage")
        .then((resp) => {
          this.resultitems = resp;
          this.onloader = "none";
        })
        .catch((err) => {
          this.onloader = "none";
          this.checkresponse(err.response.data);
        });
    },
    getsearch: function () {
      this.$store
        .dispatch("getmessagebysearch", this.searchval)
        .then((resp) => {
          this.resultitems = resp;
          //console.log(resp)
        })
        .catch((err) => {
          this.checkresponse(err.response.data);
        });
    },
    frontEndDateFormat: function (date) {
      return moment(date).format("YYYY-MM-DD");
    },
    backEndDateFormat: function (date) {
      return moment(date, "DD/MM/YYYY").format("YYYY-MM-DD");
    },
    checkresponse: function (resp) {
      if (resp === "Access Expired" || resp === "Invalid Credential") {
        this.$store.dispatch("logout");
        this.$router.push("/login");
      } else {
        console.log(resp);
        swal({
          title: "Oops!",
          text: resp.response.data,
          icon: "error",
          button: "Ok",
        });
      }
    },
  },
  mounted() {
    if (this.$store.state.auth.user_status_id != 2) {
      this.$store.dispatch("logout");
      this.$router.push("/login");
    } else {
      this.getmessage();
    }
  },
};
</script>

<style></style>
